"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployerEmployeeSearchBy = exports.EmployerLineOfBusiness = exports.EmployerProductCode = void 0;
// employer enums
var EmployerProductCode;
(function (EmployerProductCode) {
    EmployerProductCode["MEDICAL"] = "MED";
    EmployerProductCode["DENTAL"] = "DEN";
})(EmployerProductCode = exports.EmployerProductCode || (exports.EmployerProductCode = {}));
var EmployerLineOfBusiness;
(function (EmployerLineOfBusiness) {
    EmployerLineOfBusiness["BLANK"] = "";
    EmployerLineOfBusiness["BCBS"] = "BCBS";
    EmployerLineOfBusiness["BCHP"] = "BCHP";
    EmployerLineOfBusiness["NATL"] = "NATL";
    EmployerLineOfBusiness["NCDPS"] = "NCDPS";
})(EmployerLineOfBusiness = exports.EmployerLineOfBusiness || (exports.EmployerLineOfBusiness = {}));
var EmployerEmployeeSearchBy;
(function (EmployerEmployeeSearchBy) {
    EmployerEmployeeSearchBy["SSN"] = "ssn";
    EmployerEmployeeSearchBy["ID_CARD_NUMBER"] = "idCardNumber";
    EmployerEmployeeSearchBy["NAME"] = "name";
    EmployerEmployeeSearchBy["CLAIM_NUMBER"] = "claimNumber";
    EmployerEmployeeSearchBy["UNKNOWN"] = "unknown";
})(EmployerEmployeeSearchBy = exports.EmployerEmployeeSearchBy || (exports.EmployerEmployeeSearchBy = {}));
//# sourceMappingURL=employer.js.map